export type ShareResult = 'shared' | 'copied' | 'failed';

const FALLBACK_URL = 'https://mathninja.elingedice.com/';

function siteUrl(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}/`;
  }
  return FALLBACK_URL;
}

export async function shareGame(text: string, title = 'Math Ninja'): Promise<ShareResult> {
  const url = siteUrl();
  const nav = typeof navigator !== 'undefined' ? navigator : null;

  if (nav && typeof nav.share === 'function') {
    try {
      await nav.share({ title, text, url });
      return 'shared';
    } catch (err) {
      // El usuario canceló el sheet del sistema: tratarlo como "shared" (no caer al fallback).
      if ((err as DOMException)?.name === 'AbortError') return 'shared';
    }
  }

  if (nav?.clipboard?.writeText) {
    try {
      await nav.clipboard.writeText(`${text} ${url}`);
      return 'copied';
    } catch {
      /* ignore */
    }
  }
  return 'failed';
}
